const ApiConfig = {
    "fetchForms": {
        url: "srv/v1/doc/forms/",
        method: "GET",
        server: "jupiter-service"
    },
    "userLogin": {
        url: "srv/v1/user/login",
        method: "POST",
        server: "jupiter-service"
    },
    "updateUser": {
        url: "srv/v1/user/update",
        method: "POST",
        server: "jupiter-service"
    },
    "listCompany": {
        url: "srv/v1/company/list",
        method: "POST",
        server: "data-service"
    },
    "listCompanyByZerodhaSymbols": {
        url: "srv/v1/company/list",
        method: "POST",
        server: "jupiter-service"
    },
    "listConfiguration": {
        url: "srv/v1/config/list",
        method: "POST",
        server: "jupiter-service"
    },
    "saveConfiguration": {
        url: "srv/v1/config/save",
        method: "POST",
        server: "jupiter-service"
    },
    "enableConfiguration": {
        url: "srv/v1/config/enable",
        method: "PUT",
        server: "jupiter-service"
    },
    "deleteConfiguration": {
        url: "srv/v1/config/delete",
        method: "PUT",
        server: "jupiter-service"
    },
    "listMasterConfiguration": {
        url: "srv/v1/config/master/list",
        method: "POST",
        server: "jupiter-service"
    },
    "saveMasterConfiguration": {
        url: "srv/v1/config/master/save",
        method: "POST",
        server: "jupiter-service"
    },
    "enableMasterConfiguration": {
        url: "srv/v1/config/master/enable",
        method: "PUT",
        server: "jupiter-service"
    },
    "deleteMasterConfiguration": {
        url: "srv/v1/config/master/delete",
        method: "PUT",
        server: "jupiter-service"
    },
    "listUser": {
        url: "srv/v1/user/list",
        method: "POST",
        server: "jupiter-service"
    },
    "listLeverage": {
        url: "srv/v1/leverage/list",
        method: "POST",
        server: "data-service"
    },
    "listCronjobs": {
        url: "srv/v1/admin/cronjob/list",
        method: "GET",
        server: "jupiter-service"
    },
    "historyDateSummary": {
        url: "srv/v1/admin/history/date-summary",
        method: "POST",
        server: "jupiter-service"
    },
    "strategyAnlysis": {
        url: "srv/v1/analysis/strategy",
        method: "POST",
        server: "jupiter-service"
    },
    "validateCompany": {
        url: "srv/v1/company/validate",
        method: "POST",
        server: "data-service"
    },
    "listTracking": {
        url: "srv/v1/tracking/list",
        method: "POST",
        server: "jupiter-service"
    },
    "saveTracking": {
        url: "srv/v1/tracking/save",
        method: "POST",
        server: "jupiter-service"
    },
    "deleteTracking": {
        url: "srv/v1/tracking/delete",
        method: "PUT",
        server: "jupiter-service"
    },
    "enableTracking": {
        url: "srv/v1/tracking/enable",
        method: "PUT",
        server: "jupiter-service"
    },
    "fetchLeverage": {
        url: "srv/v1/leverage/fetch",
        method: "POST",
        server: "data-service"
    },
    "fetchStocksHistory": {
        url: "srv/v1/company/history/fetch",
        method: "POST",
        server: "data-service"
    },
    "historyUpdate": {
        url: "srv/v1/company/history/update",
        method: "POST",
        server: "data-service"
    },
    "fetchStocksList": {
        url: "srv/v1/company/fetch/live",
        method: "POST",
        server: "data-service"
    },
    "applyIndicators": {
        url: "srv/v1/analysis/indicators",
        method: "POST",
        server: "data-service"
    },
    "runCronJob": {
        url: "srv/v1/admin/cronjob/run",
        method: "POST",
        server: "jupiter-service"
    },
    "getAccessControl": {
        url: "srv/v1/access/control",
        method: "POST",
        server: "jupiter-service"
    },
    "saveAccessControl": {
        url: "srv/v1/access/control/save",
        method: "POST",
        server: "jupiter-service"
    },
    "listDocuments": {
        url: "srv/v1/doc/list",
        method: "POST",
        server: "jupiter-service"
    },
    "saveDocuments": {
        url: "srv/v1/doc/save",
        method: "POST",
        server: "jupiter-service"
    },
    "getZerodhaHoldings": {
        url: "srv/v1/zerodha/holdings",
        method: "GET",
        server: "jupiter-service"
    },
    "getZerodhaHoldingsTrack": {
        url: "srv/v1/zerodha/holdings/track",
        method: "POST",
        server: "jupiter-service"
    },
    "getZerodhaInstruments": {
        url: "srv/v1/zerodha/instruments",
        method: "POST",
        server: "data-service"
    },
    "monitorAlertTrades": {
        url: "srv/v1/admin/alert/trade/monitor/status",
        method: "GET",
        server: "jupiter-service"
    },
    "listAlertTrades": {
        url: "srv/v1/analysis/alert/trade/list",
        method: "POST",
        server: "jupiter-service"
    },
    "enableAlertTrades": {
        url: "srv/v1/analysis/alert/trade/enable",
        method: "PUT",
        server: "jupiter-service"
    },
    "deleteAlertTrades": {
        url: "srv/v1/analysis/alert/trade/delete",
        method: "PUT",
        server: "jupiter-service"
    },
    "updateAlertTrades": {
        url: "srv/v1/analysis/alert/trade/update",
        method: "POST",
        server: "jupiter-service"
    },
    "executeZerodha": {
        url: "srv/v1/zerodha/order",
        method: "POST",
        server: "jupiter-service"
    },
    "listTrackingTrade": {
        url: "srv/v1/analysis/alert/trade/monitor/status",
        method: "GET",
        server: "jupiter-service"
    },
}

export default ApiConfig;
